<template>
  <div class="personal-form">
    <div class="isExam" v-if="isExam">审核通过</div>  
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
        <a-row type="flex" justify="space-around">
            <a-col :span="12">
                <a-form-model-item ref="name" label="姓名" prop="name">
                    <a-input :disabled="isExam" v-model="form.name"/>
                </a-form-model-item>
            </a-col>
            <a-col :span="12">
                <a-form-model-item ref="phone" label="手机号" prop="phone">
                    <a-input :disabled="isExam" v-model="form.phone"/>
                </a-form-model-item>
            </a-col>
        </a-row>
        <a-row type="flex" justify="space-around">
            <a-col :span="12">
                <a-form-model-item ref="card" label="身份证号" prop="card">
                    <a-input :disabled="isExam" v-model="form.card"/>
                </a-form-model-item>
            </a-col>
            <a-col :span="12">
                <a-form-model-item ref="address" label="地址" prop="address">
                    <a-input :disabled="isExam" v-model="form.address"/>
                </a-form-model-item>
            </a-col>
        </a-row>
        <a-row type="flex" justify="space-around">
            <a-col :span="12">
                <a-form-model-item ref="card1Name"  label="身份证正面" prop="card1Name">
                    <upload @getFile="getFile" :disabled="isExam" :imageUrl="img1" @changeImg="changeImg" :id=4 ref="uploadyy"></upload>
                </a-form-model-item>
            </a-col>
            <a-col :span="12">
                <a-form-model-item ref="card2Name" label="身份证反面" prop="card2Name">
                    <upload @getFile="getFile" :disabled="isExam" :imageUrl="img2" @changeImg="changeImg" :id=5 ref="uploadyy"></upload>
                </a-form-model-item>
            </a-col>
        </a-row>
        <a-row>
        <a-col :span="24" style="padding-left:160px;padding-bottom:30px;">  
            温馨提示：上传图片为jpeg，png或jpg格式，且上传图片大小不能超过2MB！
        </a-col> 
        </a-row>    
        <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }" v-if="!isExam">
            <a-button type="primary" @click="onSubmit"> 提交 </a-button>
            <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
        </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import upload from '../../components/upload.vue'
export default {
  components:{
      upload
  },
  data() {
    return {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      form: {
        name:'',//"真实姓名", 
        phone:'', //"手机号", 
        card: '',//"身份证号",
        address:'', //"地址", 
        card1Name:'',//"身份证正面附件名称", 
        card1Url:'',//"身份证正面附件url", 
        card2Name:'',//"身份证反面附件名称",
        card2Url:'',//"身份证反面附件url"
      },
      img1:'',
      img2:'',
      isExam:false,
      rules: {
        name: [
            {
                required: true,
                message: "请输入姓名",
                trigger: "blur",
            }
        ],
        phone:[
            {
                required: true,
                message: "请输入手机号",
                trigger: "blur", 
            },
            {
                pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                message: '请输入正确的手机号',
                trigger: "blur", 
            }
        ],
        card:[
            {
                required: true,
                message: "请输入身份证号",
                trigger: "blur", 
            },
            {
                validator:this.checkContent
            }
        ],
        address:[
            {
                required: true,
                message: "请输入地址",
                trigger: "blur", 
            },
        ],
        card1Name:[
            {
                required: true,
                message: "请上传身份证正面",
                trigger: "blur", 
            }
        ],
        card2Name:[
            {
                required: true,
                message: "请上传身份证反面",
                trigger: "blur", 
            }
        ]
  
      },
    };
  },
  mounted(){
      this.lookForData();
  },
  methods: {
    checkContent(rule,value,callback){
        if(!this.$utils.checkIDCard(value)){
            callback('身份证号码有误')
            return
        }
        callback()
    },
    lookForData(){
        this.$https.get('/portal/certifi/getPersonByUser',this.form).then(res=>{
            if(res.code == 200){
                this.form = res.data;
                this.isExam = this.form.status == '1'?true:false
                this.img1 = res.data.card1Url;
                this.img2 = res.data.card2Url;
            }
        })
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$https.post('/portal/certifi/addPersonCertifi',this.form).then(res=>{
                if(res.code == 200){
                    this.$message.success('保存成功');
                    this.img1 = this.form.card1Url;
                    this.img2 = this.form.card2Url;
                    this.lookForData();

                }else{
                    this.$message.error(res.msg);
                }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getFile(info,id){
        if(id == 4){
            this.form.card1Name = info.file.response.data.name;
            this.form.card1Url = info.file.response.data.url;
            this.img1 = info.file.response.data.url;
        }else if(id==5){
            this.form.card2Name = info.file.response.data.name;
            this.form.card2Url = info.file.response.data.url;
            this.img2 = info.file.response.data.url;
        }
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.img1 = '';
      this.img2 = '';
    },
    changeImg(img,id){
         if(id == 4){
             this.img1 = img;
         }else if(id == 5){
             this.img2 = img;
         }
    },
  }
}
</script>

<style lang="less" scoped>
.personal-form{
    background: #fff;
    padding:0 20px;
}
.isExam{
    line-height: 30px;
    padding:0 0  20px 210px;
}
</style>